module.exports = __webpack_public_path__ + "img/67_22.d1f0bd43.png";